// Organization-related types
// Reserved slugs that cannot be used
export const RESERVED_SLUGS = [
    'admin',
    'api',
    'login',
    'signup',
    'register',
    'help',
    'support',
    'privacy',
    'terms',
    'pricing',
    'features',
    'about',
    'contact',
    'blog',
    'docs',
    'status',
    'health',
    'webhook',
    'webhooks',
    'oauth',
    'auth',
    'callback',
    'app',
    'dashboard',
    'portal',
    'book',
    'booking',
    'www',
    'mail',
    'email',
    'ftp',
    'cdn',
    'assets',
    'static',
    'images',
    'img',
    'files',
    'uploads',
];
//# sourceMappingURL=organization.js.map